module.exports = __webpack_public_path__ + "img/Grange_logo.acd90106.png";